@use '~@frontrow/console/css/variables.scss';

.licensesSummaryContainer {
  display: flex;
  font-size: variables.$font-size-sm;
  padding: variables.$std-padding-md;
  border: 1px solid variables.$gray-light-2;
  background: variables.$gray-light-3;
}

.licensesSummary {
  margin-right: variables.$std-margin-lg;
}
